"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUserFacts = exports.deserializeUserFacts = void 0;
var UserFact_1 = require("./UserFact");
exports.deserializeUserFacts = function (input) {
  var userFacts = [];
  for (var key in input.UserFacts) {
    if (input.UserFacts.hasOwnProperty(key)) {
      var userFactInput = input.UserFacts[key];
      if (userFactInput) {
        userFacts.push(UserFact_1.UserFact.deserialize(userFactInput));
      }
    }
  }
  if (userFacts.length === 0) {
    userFacts = null;
  }
  return userFacts;
};
exports.validateUserFacts = function (userFacts) {
  if (userFacts) {
    for (var key in userFacts) {
      if (userFacts.hasOwnProperty(key) && !userFacts[key]) {
        return false;
      }
    }
  }
  return true;
};